module.exports = __webpack_public_path__ + "static/media/thumbnail.89f276ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/thumbnail.png
// module id = 2215
// module chunks = 1